var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZarnica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1571",
    "data-name": "Group 1571",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255,
    height: 388.909,
    viewBox: "0 0 255 388.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 255,
    height: 388.909,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 254.999,
    height: 388.909,
    rx: 10,
    transform: "translate(0)",
    fill: "#587be1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M64,320.419,32.276,408.511H95.733c.051-.1,18.785-110.152,14.158-125.424C105.176,267.522,89.161,218.4,89,217.906a1.155,1.155,0,0,0-1.331-.774c-.37.076-9.081,1.942-9.7,9.265-.455,5.421-.234,24.481-.135,31.435-4.8-4.145-17.359-15.749-23.052-28.16a1.148,1.148,0,0,0-1.53-.569,1.13,1.13,0,0,0-.622.768,1.168,1.168,0,0,0-.44-.136c-.03,0-.057.012-.086.012,1.013-1.621,2.212-3.491,3.519-5.433,2.8-4.156,3.782-8.052,2.922-11.577a11.632,11.632,0,0,0-5.268-6.962.979.979,0,0,0-.106-.033c.124-.151.254-.311.368-.449,7.162-8.629-1.382-21.127-1.748-21.657a1.159,1.159,0,0,0-1.875-.032L41.7,194.575c-.256-3.1-1.326-14.336-3.6-17.881-2.6-4.045-10.92-7.01-11.273-7.138a1.156,1.156,0,0,0-1.539,1.084l-.145,45.547a1.114,1.114,0,0,0,.088.375l-5.393,7.2a1.158,1.158,0,0,0-.222.83s6.254,50.657,6.391,50.824Z",
    transform: "translate(-2.268 -19.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M41.035,196.221,24.164,218.742l-5.382,7.185",
    transform: "translate(-2.172 -22.693)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M22.056,248.147C28.124,240,45.79,216.409,51.733,209.658",
    transform: "translate(-2.551 -24.247)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M32.878,257.438l21.613-21.32s5.637,7.84,3.3,13.363-11.742,15.977-11.742,15.977l3.254,11.991s16.25,2.342,26.367,16.25",
    transform: "translate(-3.802 -27.307)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M213.441,320.419l31.729,88.092H181.712c-.051-.1-18.785-110.152-14.158-125.424,4.714-15.565,20.729-64.686,20.89-65.181a1.155,1.155,0,0,1,1.331-.774c.37.076,9.081,1.942,9.7,9.265.455,5.421.234,24.481.135,31.435,4.8-4.145,17.359-15.749,23.052-28.16a1.148,1.148,0,0,1,1.53-.569,1.13,1.13,0,0,1,.622.768,1.168,1.168,0,0,1,.44-.136c.03,0,.057.012.086.012-1.013-1.621-2.212-3.491-3.519-5.433-2.8-4.156-3.782-8.052-2.922-11.577a11.632,11.632,0,0,1,5.268-6.962.979.979,0,0,1,.106-.033c-.124-.151-.254-.311-.368-.449-7.162-8.629,1.382-21.127,1.748-21.657a1.159,1.159,0,0,1,1.875-.032l8.217,10.969c.256-3.1,1.326-14.336,3.6-17.881,2.6-4.045,10.92-7.01,11.273-7.138a1.156,1.156,0,0,1,1.539,1.084l.145,45.547a1.114,1.114,0,0,1-.088.375l5.393,7.2a1.158,1.158,0,0,1,.222.83s-6.254,50.657-6.391,50.824Z",
    transform: "translate(-19.293 -19.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M244.549,196.221l16.871,22.521,5.382,7.185",
    transform: "translate(-28.282 -22.693)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M262.557,248.147c-6.068-8.142-23.734-31.738-29.677-38.489",
    transform: "translate(-26.932 -24.247)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M250.02,257.438l-21.613-21.32s-5.637,7.84-3.3,13.363,11.742,15.977,11.742,15.977l-3.254,11.991s-16.25,2.342-26.367,16.25",
    transform: "translate(-23.965 -27.307)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M75.016,109.173C74.4,69.685,110.9,38.282,152.184,48.46A59.91,59.91,0,0,1,195.2,89.553c8.8,29.795-4.38,57.8-27.155,71.522l.371,23.733-61.465.969-.371-23.734a61.633,61.633,0,0,1-31.569-52.87",
    transform: "translate(-8.675 -5.381)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M152.559,188.56s-1.3-56.794,3.659-73.358c1.767-5.907,13.256-22.424,20.22-14.163s-21.423,37.575-36.55,19.943c-9.081-10.583-14.577-45.419-2.248-42.914,7.355,1.495,15.1,42.316.885,47.587-18.982,7.037-29.23-10.99-30.055-17s20.485,5.018,22.491,26.263.91,54.88.91,54.88",
    transform: "translate(-12.542 -9.014)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M123.729,247.97l37.671-.585A11.9,11.9,0,0,0,173.11,235.3l-.515-32.407-61.462.956.515,32.415a11.9,11.9,0,0,0,12.08,11.706",
    transform: "translate(-12.853 -23.464)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 67.291,
    y2: 1.046,
    transform: "translate(94.74 194.455)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 67.291,
    y2: 1.046,
    transform: "translate(94.74 182.08)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarnica);
export default __webpack_public_path__ + "static/media/zarnica.4f21b94c256d98a4ac9daed391d04ec4.svg";
export { ForwardRef as ReactComponent };